'use strict';

/**
 * TKV Animal Chooser
 *
 * Responsibilities:
 *  - Sticky behaviour (mobile bottom CTA / desktop pinned top).
 *  - Submit: navigate to the comparison target of the selected animal.
 *
 * Min prices are rendered server-side (see MinPriceService / tkv-animal-chooser.html.twig).
 *
 * Desktop: when the form scrolls out of view, pin the full chooser to the top
 * with a placeholder. CSS position:sticky cannot be used here — the parent is
 * too short, so sticky would stop almost immediately.
 */
(function() {
    var MOBILE_BREAKPOINT = '(max-width: 767px)';

    // ------------------------------------------------------------------- submit
    function initSubmit(form) {
        form.addEventListener('submit', function(event) {
            var selected = form.querySelector('input[name="target"]:checked');
            var target = selected && selected.dataset.url;
            if (target) {
                event.preventDefault();
                window.location.href = target;
            }
        });
    }

    // --------------------------------------------------------- sticky behaviour

    function getVisibleOnscroll() {
        var containers = document.querySelectorAll('.tkv-animal-chooser__onscroll');
        for (var i = 0; i < containers.length; i++) {
            if (containers[i].offsetParent !== null) {
                return containers[i];
            }
        }
        return null;
    }

    function initMobileStickyBar(container) {
        var form = container.querySelector('.tkv-animal-chooser__form');
        var stickyBar = container.parentElement
            && container.parentElement.querySelector('.tkv-animal-chooser__sticky-bar');
        if (!form || !stickyBar) {
            return;
        }

        stickyBar.querySelector('.tkv-animal-chooser__button').addEventListener('click', function() {
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
            } else {
                form.submit();
            }
        });

        if (!('IntersectionObserver' in window)) {
            return;
        }

        var observer = new IntersectionObserver(function(entries) {
            stickyBar.classList.toggle(
                'tkv-animal-chooser__sticky-bar--visible',
                !entries[0].isIntersecting
            );
        });
        observer.observe(container);
    }

    function initDesktopStickyTop(container) {
        var placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        container.parentNode.insertBefore(placeholder, container);

        var isSticky = false;

        function makeSticky() {
            if (isSticky) {
                return;
            }
            placeholder.style.display = 'block';
            placeholder.style.height = container.offsetHeight + 'px';
            container.classList.add('tkv-animal-chooser__onscroll--sticky');
            isSticky = true;
        }

        function makeUnsticky() {
            if (!isSticky) {
                return;
            }
            container.classList.remove('tkv-animal-chooser__onscroll--sticky');
            placeholder.style.display = 'none';
            placeholder.style.height = '0';
            isSticky = false;
        }

        var sentinel = document.createElement('div');
        sentinel.style.height = '1px';
        sentinel.style.marginBottom = '-1px';
        sentinel.style.pointerEvents = 'none';
        container.parentNode.insertBefore(sentinel, placeholder);

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                        makeSticky();
                    } else if (entry.isIntersecting) {
                        makeUnsticky();
                    }
                });
            }, { threshold: 0 });
            observer.observe(sentinel);
        } else {
            var onScroll = function() {
                if (sentinel.getBoundingClientRect().top < 0) {
                    makeSticky();
                } else {
                    makeUnsticky();
                }
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }
    }

    // --------------------------------------------------------------------- init

    function init() {
        var container = getVisibleOnscroll();
        if (!container) {
            return;
        }

        var form = container.querySelector('.tkv-animal-chooser__form');
        if (form) {
            initSubmit(form);
        }

        if (window.matchMedia(MOBILE_BREAKPOINT).matches) {
            initMobileStickyBar(container);
        } else {
            initDesktopStickyTop(container);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
